import Documents from "../../modules/documents/views/Documents.vue";
import Benefactor from "../../modules/benefactor/views/Benefactor.vue";
import Absence from "../../modules/absence/views/Absence.vue";
import FuneralAssistance from "../../modules/funeral-assistance/views/FuneralAssistance.vue";
import Declaration from "../../modules/declarations/views/Declarations.vue";
import CooperativeDeclaration from "../../modules/cooperative-declaration/views/CooperativeDeclaration.vue";
import RouterViewRender from "../../utils/routes/router-view-render";
import TemporaryAssistance from "../../modules/temporary-assistance/views/TemporaryAssistance.vue";
import HealthPlan from "../../modules/health-plan/views/HealthPlan.vue";
import { PermissionList } from "../../static-data/PermissionList";
import { IsAbleNavigation } from "../utils/is-able-navigation";

const DocumentsRoutes = {
  path: "documentos",
  component: RouterViewRender,
  beforeEnter: (to, from, next) =>
    IsAbleNavigation(to, from, next, PermissionList.DOCUMENTS_MENU),
  children: [
    {
      path: "",
      component: Documents,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "benemerito",
      component: Benefactor,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "auxilio-funeral",
      component: FuneralAssistance,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "afastamento",
      component: Absence,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "auxilio-temporario",
      component: TemporaryAssistance,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "declaracoes",
      component: Declaration,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "declaracao-cooperado",
      component: CooperativeDeclaration,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "plano-saude",
      component: HealthPlan,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default DocumentsRoutes;
